/* eslint-disable no-restricted-globals */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './NormalizationContainer.scss';

const ROW_NAME = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P'];

class NormalizationViewVolumeList extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  shouldComponentUpdate(nextProps) {
    const {normalizationState: oldNormalizationState} = this.props;
    const {
      reagentName: oldReagentName,
      csvData: oldCsvData,
      targetConcentration: oldTargetConcentration,
      previewData: oldPreviewData,
    } = oldNormalizationState;

    const {normalizationState} = nextProps;
    const {reagentName, csvData, targetConcentration, previewData} = normalizationState;

    if (oldPreviewData !== previewData) {
      return true;
    }

    if (oldTargetConcentration !== targetConcentration) {
      return true;
    }

    if (oldCsvData !== csvData) {
      return true;
    }

    if (oldReagentName !== reagentName) {
      return true;
    }

    return false;
  }

  createTableData() {
    const {normalizationState} = this.props;
    const {previewData, targetConcentration} = normalizationState;

    const rows = [];

    // generate table content
    for (let row = 0; row < previewData.length; row += 1) {
      rows.push(
        <tr key={`row-${row}`}>
          <td>{`${ROW_NAME[previewData[row].row]}${previewData[row].col + 1}`}</td>
          <td>{previewData[row].reagentCurrentConcentration}</td>
          <td>{targetConcentration}</td>
          <td>{isNaN(previewData[row].diluentVol) ? 0 : previewData[row].diluentVol}</td>
        </tr>,
      );
    }

    return rows;
  }

  render() {
    const {normalizationState} = this.props;
    const {csvData, reagentName} = normalizationState;

    const tableData = this.createTableData();

    return (
      <div className="volume-list-container">
        <div className="title-section">Volume List</div>
        <div className={`volume-list-table-section${csvData.length === 0 ? '-empty' : ''}`}>
          <table className="table">
            <thead>
              <tr>
                <td className="table-header-title">Well</td>
                <td className="table-header-title">{reagentName}</td>
                <td className="table-header-title">Target Concentration</td>
                <td className="table-header-title">Diluent Volume (µL)</td>
              </tr>
            </thead>
            <tbody>{tableData}</tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default NormalizationViewVolumeList;

NormalizationViewVolumeList.propTypes = {
  normalizationState: PropTypes.any.isRequired,
};
